<template>
  <div class="row h-100">
    <div class="col-md-12 h-100">
      <IbRolesRequired v-if="isRoleRequired" />
      <router-view v-else class="h-100" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import * as mutation from '@/store/mutation-types';
import IbRolesRequired from '@/components/IbRequiredRoles.vue';

const DEFAULT_CONFIG = {
  Id: 0,
  DisplayName: 'No Filters Selected',
  IsDefault: true,
  PersistenceTypeId: 2,
  PersistedSetting: {
    WarrantyJobsOnly: false,
    NonGoldServiceEngineersOnly: false,
    DocumentsToApproveOnly: false,
    MultipleEngineersOnly: false,
    PartsOnOrderOnly: false,
    HideRepeatable: false,
    InvoiceType: [],
    GoldStatus: '',
    Department: [],
    Columns: [],
    Depot: 1
  },
};

export default {
  name: 'Workshop',
  components: { IbRolesRequired },

  /**
   * Fetch the jobs when the component is loaded in.
   */
  created() {
    this.initJobFetching();
  },

  /**
   * Clear down state before destroying component.
   */
  beforeDestroy() {
    this.clearEngineers();
  },

  computed: {
    ...mapGetters('system', {
      companyId: 'currentCompanyId',
      depotId: 'currentDepotId',
      isRoleRequired: 'isRoleRequired',
    }),
    ...mapGetters('kanban', {
      cachedFilterConfig: 'filterConfig',
    }),
  },

  watch: {
    companyId: {
      immediate: true,
      handler(newValue) {
        // Reload the engineers and the jobs when
        // the selected company changes.
        if (newValue) {
          this.fetchEngineers();
          if (!this.isKanban()) this.fetchJobs();
        }
      },
    },

    depotId: {
      immediate: true,
      handler(newValue) {
        // Reload the jobs when the selected depot changes.
        if (newValue) {
          if (!this.isKanban()) this.fetchJobs();
        }
      },
    },
  },

  methods: {
    ...mapMutations('engineer', {
      clearEngineers: mutation.RESET,
    }),

    ...mapActions('engineer', {
      fetchEngineers: 'fetchEngineers',
    }),

    ...mapActions('job', {
      fetchActiveJobs: 'fetchActiveJobs',
      fetchLoggedJobs: 'fetchLoggedJobs',
      clearJobs: 'clearJobs',
    }),

    isKanban() {
      return this.$router.currentRoute?.name === "JobsKanban";
    },

    async initJobFetching() {
      if (!this.isKanban()) {
        this.fetchJobs();
        return;
      }

      //If landing onto the Kanban page (from a complete refresh or page navigation), the load events from this parent component can interfere with the child, JobsKanban.vue making the parents data load before the child has filtered it.
      //The filters are computed so they need time to initalise.
      let attempts = 0;
      const  attemptTotal = 40;
      while (
        (!this.cachedFilterConfig || Object.keys(this.cachedFilterConfig).length === 0) &&
        attempts < attemptTotal
      ) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }

      if(attempts >= attemptTotal)
      {
        console.log("Attemps exceeded "+ attemptTotal +" : " + attempts);
      }

      this.fetchJobs();
    },

    fetchJobs() {
      const config = this.cachedFilterConfig;

      const isIdUndefined = config?.Id === undefined;
      const hasNoPersistedSettings = !this.isFilterCleared(config);

      if (isIdUndefined && hasNoPersistedSettings) { //also check to see if persisted settings are set - meaning we are still filtering but not on a saved filter.
        this.fetchActiveJobs({
          depot: this.depotId,
          config: DEFAULT_CONFIG,
        });
        this.fetchLoggedJobs({
          depot: this.depotId,
          config: DEFAULT_CONFIG,
        });
      }
    },

    //Taken from JobsKanban to check if filters exist.
    isFilterCleared(filter) {
      const settings = Object.entries(filter.PersistedSetting || {});
      return settings.some(([key, value]) => {
        if (value?.constructor?.name === "Object") return true;
        if (Array.isArray(value) && value.length > 0) return true;
        if (value === true) return true;
        return false;
      });
    },
  },


  
};
</script>
